import { Button } from '@cropler/ui-kit';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

import styles from './stylesChartLegend.module.scss';

import { AiAnalyticsLabel } from '../AiAnalytics/index.jsx';
import { BreakpointTablet } from '../../constants/ui';

const ChartLegend = ({
  sensors,
  title,
  title2,
  units,
  units2,
  color,
  color2,
  id,
  id2,
  widthViewport,
  onDownloadCsv,
}) => {
  return (
    <div className={styles.chartLegend}>
      <div className={styles.chartLegendItem}>
        <h2 className={styles.chartLegendTitle}>
          {id === 'bbch' && (
            <div className={styles.chartLegendTitleAi}>
              <AiAnalyticsLabel size={'small'} hideTooltip={true} />
            </div>
          )}
          {title2 && <span className={styles.chartLegendIndicator} style={{ color: color }}></span>}
          <span>{title}</span>
          {units && <span className={styles.chartLegendUnits}>, {units}</span>}
        </h2>
        <Button type="secondary" className={styles.chartLegendButton} icon={<CroplerIcon name="download" />} onClick={onDownloadCsv} />

        {sensors.length > 1 && widthViewport > BreakpointTablet && (
          <div className={`${styles.chartLegendSensors} ${title2 ? styles.chartLegendSensorsWide : ''}`}>
            <div className={styles.chartLegendSensor}>
              <span className={styles.chartLegendIndicator} style={{ color: color }}></span>
              {sensors[0]}
            </div>
            <div className={styles.chartLegendSensor}>
              <span
                className={`${styles.chartLegendIndicator} ${styles.chartLegendIndicatorDashed}`}
                style={{ color: color }}
              ></span>
              {sensors[1]}
            </div>
          </div>
        )}
      </div>

      {title2 && (
        <div className={styles.chartLegendItem}>
          {sensors.length > 1 && widthViewport > BreakpointTablet && (
            <>
              <div className={styles.chartLegendSensor}>
                <span className={styles.chartLegendIndicator} style={{ color: color2 }}></span>
                {sensors[0]}
              </div>
              <div className={styles.chartLegendSensor}>
                <span
                  className={`${styles.chartLegendIndicator} ${styles.chartLegendIndicatorDashed}`}
                  style={{ color: color2 }}
                ></span>
                {sensors[1]}
              </div>
            </>
          )}
          <h2 className={styles.chartLegendTitle}>
            {id2 === 'bbch' && (
              <div className={styles.chartLegendTitleAi}>
                <AiAnalyticsLabel size={'small'} hideTooltip={true} />
              </div>
            )}
            <span className={styles.chartLegendIndicator} style={{ color: color2 }}></span>
            <span>{title2}</span>
            {units2 && <span className={styles.chartLegendUnits}>, {units2}</span>}
          </h2>
        </div>
      )}
    </div>
  );
};

export default ChartLegend;
